import React from 'react';
import '../myutils';
import DataIcon from '@material-ui/icons/PermDataSetting';
import FolderIcon from '@material-ui/icons/FolderOpen';
import EditIcon from '@material-ui/icons/Edit';
import PlayIcon from '@material-ui/icons/PlayArrow';
import ShowChart from '@material-ui/icons/ShowChart';
import RouterIcon from '@material-ui/icons/Router';
import MusicIcon from '@material-ui/icons/LibraryMusic';
import MenuIcon from '@material-ui/icons/Menu';
import RecordIcon from '@material-ui/icons/FiberManualRecord';
import VoicemailIcon from '@material-ui/icons/Voicemail';
import RecordDataIcon from '@material-ui/icons/RecordVoiceOver';
import SaleIcon from '@material-ui/icons/Store';
import GotoIcon from '@material-ui/icons/FolderSpecial';
import QueueIcon from '@material-ui/icons/Queue';
import RoutingYemotIcon from '@material-ui/icons/Phonelink';
import RoutingTimeIcon from '@material-ui/icons/Timelapse';
import TimeKeeperIcon from '@material-ui/icons/Timer10';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import TriviaIcon from '@material-ui/icons/QuestionAnswer';
import PointsIcon from '@material-ui/icons/Stars';
import ConfIcon from '@material-ui/icons/PhonelinkSetup';
import PlayfileTimeIcon from '@material-ui/icons/Timer';
import DonationIcon from '@material-ui/icons/AttachMoney';
import StudyIcon from '@material-ui/icons/TrackChanges';
import AdminLoginIcon from '@material-ui/icons/Face';
import TemplateAddIcon from '@material-ui/icons/PersonAdd';
import TemplateRemoveIcon from '@material-ui/icons/Remove';
import IdListMessageIcon from '@material-ui/icons/Group';
import IdMessageIcon from '@material-ui/icons/Message';
import MenuVoiceIcon from '@material-ui/icons/Menu';
import TemplateFilterIcon from '@material-ui/icons/Filter';
import GotoFolderIcon from '@material-ui/icons/Forward';
import PhoneHangupIcon from '@material-ui/icons/PhonelinkOff';
import BlockIcon from '@material-ui/icons/Block';
import DialerIcon from '@material-ui/icons/DialerSip';
import PhoneIcon from '@material-ui/icons/LocalPhone';
import ChartIcon from '@material-ui/icons/ShowChart';
import ComputerIcon from '@material-ui/icons/Computer';
import BookIcon from '@material-ui/icons/Book';
import TimeIcon from '@material-ui/icons/AccessTime';
import CodeIcon from '@material-ui/icons/Code';

const icons = 
{   
    DIR: <FolderIcon />, AUDIO: <PlayIcon />, YMGR: <ShowChart />, CSV: <ShowChart />, HTML: <ShowChart />,
    INI: <EditIcon />, BIN: <DataIcon />, routing: <RouterIcon/>, playfile: <MusicIcon/>, menu :<MenuIcon/>, record :<RecordIcon/>, voicemail_email :<VoicemailIcon/>,
    recording_and_entering_data :<RecordDataIcon/>, sale_products :<SaleIcon/>, go_to_folder :<GotoIcon/>, queue :<QueueIcon/>, routing_yemot :<RoutingYemotIcon/>, routing_time :<RoutingTimeIcon/>,
    routing_ip :<RouterIcon/>, routing_1800 :<RouterIcon/>, credit_card :<CreditCardIcon/>, trivia_questions :<TriviaIcon/>, examination :<TriviaIcon/>, points_say_total :<PointsIcon/>, points_save :<PointsIcon/>,
    points_to_other_id :<PointsIcon/>, points_edit :<PointsIcon/>, confbridge :<ConfIcon/>, playfile_time :<PlayfileTimeIcon/>, study_tracking :<StudyIcon/>, donation_campaign :<DonationIcon/>,
    donation_campaign_some_actions :<DonationIcon/>, time_keeper :<TimeKeeperIcon/>, admin_login :<AdminLoginIcon/>, template_add_number :<TemplateAddIcon/>, template_remove_number :<TemplateRemoveIcon/>,
    id_list_message :<IdListMessageIcon/>, id_message :<IdMessageIcon/>, menu_voice :<MenuVoiceIcon/>, template_filter :<TemplateFilterIcon/>, go_to_folder_time :<GotoFolderIcon/>, access_filter :<TemplateFilterIcon/>,
    go_to_folder_from_list_all_information :<GotoFolderIcon/>, go_to_folder_count :<GotoFolderIcon/>, go_to_folder_date :<GotoFolderIcon/>, folder_play_random :<PlayIcon/>, toplay_time :<PlayfileTimeIcon/>,
    key_play_set_record_go_to_foldar :<GotoFolderIcon/>, hangup :<PhoneHangupIcon/>, block_id_type :<BlockIcon/>, yemot_dialer_campaign_list :<DialerIcon/>, send_fax :<PhoneIcon/>, recv_fax :<PhoneIcon/>,
    sale_seats :<SaleIcon/>, seker :<ChartIcon/>, tasks_report :<ChartIcon/>, calculator_add_percentage :<ComputerIcon/>, daily_message :<IdMessageIcon/>, chapter_receive_mishnayot_select :<BookIcon/>,
    chapter_receive :<BookIcon/>, tehillim_select_save_and_listen :<BookIcon/>, zmanim :<TimeIcon/>, say_sabbath_time :<TimeIcon/>, approval_number :<CodeIcon/>, coupon :<CodeIcon/>,
    number_now_is :<CodeIcon/>, say_hour_and_minute :<TimeIcon/>, music_on_hold :<PlayIcon/>, record_system_messages :<RecordIcon/>, api :<RouterIcon/>, yemot_dialer_campaign_start :<PhoneIcon/>,
    private_did_customer :<CodeIcon/>, limit_call_seconds :<PhoneHangupIcon/>, points_and_rating :<PointsIcon/>, phone_play_list :<PlayIcon/>, fundraising :<SaleIcon/>, start_select_file :<PlayIcon/>
}

export default icons; 